// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2kER9","search":"Settings_search__36FVO","filter":"Settings_filter__1uz7m"};